export class CommandUniformMap {
    constructor(stateName) {
    }
    addShaderUniform(propertyID, propertyKey, uniformtype) {
        throw "need override it";
    }
    addShaderUniformArray(propertyID, propertyName, uniformtype, arrayLength) {
        throw "need override it";
    }
}
